import Service from "../../AuthService";

const Seller = {
    getSeller() {
        return Service.get("/seller");
    },
    showSeller(id) {
        return Service.get("/seller/" + id);
    },
    updateSeller(id, data) {
        return Service.put("/seller/" + id, data);
    },
    createSeller(data) {
        return Service.post("/seller", data);
    },
    deleteSeller(id) {
        return Service.delete("/seller/" + id);
    },
    searchSeller(keyword) {
        return Service.post("/search-seller?sale=" + keyword);
    },
    getCustomerFromSale(data){
        console.log("/customer-from-sale?sale_id="+data);
        return Service.get("/customer-from-sale?sale_id="+data);
    }
};
export default Seller;
